/* eslint-disable camelcase */

import { computed, makeObservable, observable, override, toJS } from 'mobx'
import moment from 'moment'
import Equipment from './Equipment'
import Event from './Event'
import ClientsAddress from './ClientsAddress'
import Model from './Model'

class ClientsAddressesEquipment extends Model {
  @observable id = 0
  @observable equipment_id = 0
  @observable client_id = 0
  @observable clients_address_id = 0
  @observable inspection_frequency = ''
  @observable last_inspection_id = 0
  @observable next_inspection_id = 0

  @observable forms = []

  /**
   *
   * @type {Equipment}
   */
  @observable equipment = null
  /**
   * @type {Event}
   */
  @observable next_event = null
  /**
   * @type {Event}
   */
  @observable last_event = null
  @observable last_inspection = null
  @observable next_inspection = null
  /**
   *
   * @type {ClientsAddress}
   */
  @observable clients_address = null

  @observable status = null
  @observable created = null
  @observable modified = null

  _fieldToSave = [
    'equipment_id',
    'inspection_frequency',
    'forms'
  ]

  @computed
  get lastInspectionDate () {
    if (!this.last_event) {
      return 'Non disponible'
    }
    return moment(this.last_event.date_start).format('YYYY-MM-DD hh:mm:ss')
  }

  @computed
  get nextInspectionDate () {
    if (this.next_event) {
      return moment(this.next_event.date_start).format('YYYY-MM-DD hh:mm:ss')
    } else if (this.last_event) {
      return moment(this.last_event.date_start).add(moment.duration(this.inspection_frequency)).format('YYYY-MM-DD hh:mm:ss')
    } else {
      return 'Non disponible'
    }
  }

  @computed
  get inspectionFrequency () {
    return ClientsAddressesEquipment.INSPECTION_FREQUENCY[this.inspection_frequency]
  }

  constructor () {
    super()
    makeObservable(this)
  }

  @override
  setData (data) {
    const { equipment, forms, clients_address, next_event, ...rest } = data
    if (equipment) {
      this.equipment = new Equipment()
      this.equipment.setOriginalData(equipment)
    }
    if (forms) {
      super.setData({ forms: typeof forms === 'string' ? JSON.parse(forms) : forms })
    }
    if (clients_address) {
      this.clients_address = new ClientsAddress()
      this.clients_address.setOriginalData(clients_address)
    }
    if (next_event) {
      this.next_event = new Event(next_event)
    }
    super.setData(rest)
  }

  toJson () {
    const clientsAddressEquipment = {}
    for (const props of this._fieldToSave) {
      clientsAddressEquipment[props] = toJS(this[props])
    }
    return clientsAddressEquipment
  }
}

ClientsAddressesEquipment.INSPECTION_FREQUENCY = {
  T0M: 'Unique',
  P1Y: 'Annuel',
  P6M: 'Bi-annuel',
  P3M: 'Trimestre',
  P1M: 'Mensuel',
  P7D: 'Hebdomadaire',
  P1D: 'Quotidien'
}
export default ClientsAddressesEquipment
